import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "para continuar debera ingresar una nueva contraseña.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { class: "p-fluid tw-space-y-4" }
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "p-mt-2" }, "Sugerencias:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ul", {
  class: "p-pl-2 p-ml-2 p-mt-0",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("li", null, "Minimo 8 caracteres"),
  /*#__PURE__*/_createElementVNode("li", null, "Una letra en mayusculas"),
  /*#__PURE__*/_createElementVNode("li", null, "al menos un numero")
], -1)
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = { class: "tw-w-full tw-text-sm tw-text-red-500" }
const _hoisted_9 = { class: "tw-space-y-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "tw-mt-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-xs" }, "Desarrollado por Gobal App®")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", {
    class: "cambio-pass tw-w-full tw-h-screen tw-flex tw-justify-center tw-items-center tw-p-2",
    style: _normalizeStyle(`background-image:url(${_ctx.BackgroundImage});`)
  }, [
    _createVNode(_component_Card, {
      class: _normalizeClass(["tw-w-full md:tw-w-6/12 lg:tw-w-5/12 xl:tw-w-3/12 tw-p-4 p-shadow-5", {"animate-in":!_ctx.isOut,"animate-out":_ctx.isOut}])
    }, {
      title: _withCtx(() => [
        _createElementVNode("h2", null, "Bienvenido!, " + _toDisplayString(_ctx.$store.state.pacienteLogueado?.nombre || ''), 1)
      ]),
      subtitle: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Password, {
              placeholder: "Nueva Contraseña",
              toggleMask: "",
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event))
            }, {
              footer: _withCtx(() => [
                _createVNode(_component_Divider),
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Password, {
              loading: _ctx.isLoad,
              placeholder: "Repita la Contraseña",
              toggleMask: "",
              modelValue: _ctx.passwordRepeat,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordRepeat) = $event)),
              feedback: false
            }, null, 8, ["loading", "modelValue"])
          ]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.error), 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Button, {
            label: "Ingresar",
            class: "tw-w-full",
            onClick: _ctx.handleClick
          }, null, 8, ["onClick"]),
          _hoisted_10
        ]),
        _hoisted_11
      ]),
      _: 1
    }, 8, ["class"])
  ], 4))
}